

































































import { Component, Mixins, Emit, Prop } from "vue-property-decorator";
import { WorkflowListViewMixin, ReceptionDetailPaneMixin } from "./../mixins";
import { DialogMixin } from "../../system/mixins";
import ReceptionContent from "./../lists/ReceptionContent.vue";
import CommentTabSelector from "./../selectors/CommentTabSelector.vue";
import ReceptionDeliveryGeneralFlagEditor from "../editors/controls/ReceptionDeliveryGeneralFlagEditor.vue";
import { ReceptionReference } from "../../../domain/workflow/reference";
import { ReceptionReferenceKinds } from "../../../domain/workflow/kinds";
import { DomainRegistry } from "../../../domain";
import { Patient } from "../../../domain/patient";
import CommentDialog from "./CommentDialog.vue";
import WorkflowActionDialog from "./WorkflowActionDialog.vue";
import WorkflowActionConfirmDialog from "./WorkflowActionConfirmDialog.vue";

@Component({
  components: {
    ReceptionContent,
    CommentTabSelector,
    ReceptionDeliveryGeneralFlagEditor,
  }
})

export default class WorkflowListDetailDialog extends Mixins(DialogMixin, WorkflowListViewMixin, ReceptionDetailPaneMixin) {
  @Prop()
  workflowActionDialog: WorkflowActionDialog;

  @Prop()
  workflowActionConfirmDialog: WorkflowActionConfirmDialog;

  @Prop()
  commentDialog: CommentDialog;

  @Emit()
  wfDetailAction(): void {}

  @Emit()
  wfDetailDeleted(): void {}

  title: string;
  patient: Patient;

  data(): any {
    return {
      title: "",
      patient: null as Patient,
      defaultDisplayKind: null as ReceptionReferenceKinds,
      isReadOnly: false,
    };
  }
  defaultDisplayKind: ReceptionReferenceKinds;
  isReadOnly: boolean;

  mounted() {
    this.automaticallyChecked = this.shouldSwitchAutomatically;
  }

  get automaticSwitchingWidth(): number {
    return this.$configuration.behavior.reception.list.detailDialog.panes.automaticSwitchingWidth;
  }

  get shouldSwitchAutomatically(): boolean {
    return (0 < this.automaticSwitchingWidth);
  }

  get shouldShowCommentTabRightSide(): boolean {
    return this.automaticallyChecked
        ? (this.automaticSwitchingWidth < this.windowWidth)
        : this.isSelectedRightSide;
  }

  get layoutClass(): string {
    return this.shouldShowCommentTabRightSide
      ? "horizontal"
      : "vertical";
  }

  get patientInformation(): string {
    return this.patient
      ? this.patient.id + " " + this.patient.name + "（" + this.patient.kanaName + "）"
      : "";
  }

  async getDetail(): Promise<void> {
    if (this.detailId) {
      this.loadingReferenceSource = this.detailId;
      const result = await this.getReference(this.detailId);
      this.loadingReferenceSource = null;
      this.reference = result;
    }
  }

  async getReference(receptionDetailId: number): Promise<ReceptionReference> {
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    return repository.getReceptionDetailReference(receptionDetailId);
  }

  private registerEvent(): void {
    window.addEventListener("message", this.onUpdateMessageReceived, false);
  }

  onDeletedDetail() {
    this.$logger.debug("依頼削除通知");
    this.reference = null;
    this.getDetail();
    this.wfDetailDeleted();
  }

  onDoActionedDetail() {
    this.$logger.debug("WF実行通知");
    this.reference = null;
    this.getDetail();
    this.wfDetailAction();
  }

  onGeneralFlagUpdated(): void {
    this.$logger.debug("汎用フラグ更新通知");
    this.reference = null;
    this.getDetail();
    this.generalFlagUpdated();
  }

  onUpdateMessageReceived(event: MessageEvent): void {
    if (!event.data || typeof event.data !== "string") { return; }
    const message = JSON.parse(event.data);
    this.$logger.debug("postMessage受信");
    console.log(message);

    switch (message.key) {
      case "receptionRegistered":
        this.$logger.info("依頼が登録されました");
        this.getDetail();
        break;
      case "wfDocumentRegistered":
        this.$logger.info("WF文書が登録されました");
        this.getDetail();
        break;
      case "wfActioned":
        this.$logger.info("WF処理が実行されました");
        this.getDetail();
        break;
      default:
    }
  }

  async show(id: number, patient: Patient, defaultDisplayKind: ReceptionReferenceKinds, isReadOnly: boolean) {
    return this.showModal(async () => {
      this.title = "ワークフロー詳細";
      this.detailId = id;
      this.patient = patient;
      this.defaultDisplayKind = defaultDisplayKind;
      this.isReadOnly = isReadOnly;
      this.registerEvent();
      await this.getDetail();
      await this.waitHidden();
      this.defaultDisplayKind = null as ReceptionReferenceKinds;
      return this;
    });
  }
}
